// @flow
import React, { Fragment } from 'react'
import ErrorVibesLink from './controls/ErrorVibesLink'
import ConnectionAccountSelect from './ConnectionAccountSelect'
import styled from 'styled-components'
import postJson from '../services/postJson'

const RemoveToken = styled.a`
  padding: 6px 0 0 18px;
`

export type Props = {|
  selectedAccount: any,
  getAccountsUrl: string,
  setAccountUrl: string,
  isLoading: boolean,
  resetTokenUrl: string,
  reloadAccountsUrl: string,
  loadedAccounts: any,
  error: any,
  provider: string,
  providerTitle: string,
  login: any,
  instruction: any,
  isTokenDeactivated: boolean,
  isTokenPresent: boolean,
  getTokenUrl: string,
  getTokenTitle: string,
  refreshTokenTitle: string,
  onReload: () => void
|}

export default function ConnectionAccountRow(props: Props) {
  return (
    <tr className={`main-table__body-row ${props.provider}-provider`}>
      <td className="main-table__cell">{props.providerTitle}</td>
      <td className="main-table__cell">{props.login}</td>
      <td className="main-table__cell">
        {props.instruction && (
          <p
            className="connection-table__provider-instruction"
            dangerouslySetInnerHTML={{ __html: props.instruction }}
          />
        )}
        {renderInteractiveCell(props)}
      </td>
    </tr>
  )
}

const removeMyTargetTokenPath = '/api/v1/provider_tokens/target_mail/delete'

function renderInteractiveCell(props: Props) {
  if (props.isTokenDeactivated) {
    return (
      <ErrorVibesLink href={props.getTokenUrl} className="top-info__button top-info__button_no-m">
        {props.refreshTokenTitle}
      </ErrorVibesLink>
    )
  }

  if (!props.isTokenPresent) {
    return (
      <a href={props.getTokenUrl} className="top-info__button top-info__button_no-ml">
        {props.getTokenTitle}
      </a>
    )
  }

  return (
    <Fragment>
      <ConnectionAccountSelect
        getAccountsUrl={props.getAccountsUrl}
        setAccountUrl={props.setAccountUrl}
        provider={props.provider}
        selectedAccount={props.selectedAccount}
        error={props.error}
        resetTokenUrl={props.resetTokenUrl}
        reloadAccountsUrl={props.reloadAccountsUrl}
        isLoading={props.isLoading}
        loadedAccounts={props.loadedAccounts}
      />
      {props.provider === 'target_mail' && (
        <RemoveToken href="#" onClick={(e) => removeMyTargetToken(e, props.onReload)}>
          Отвязать аккаунт myTarget
        </RemoveToken>
      )}
    </Fragment>
  )
}

function removeMyTargetToken(e, callback: () => void) {
  e.preventDefault()
  postJson(removeMyTargetTokenPath)
    .done(() => {})
    .fail(() => window.alert('Some error occured'))
    .always(() => callback())
}
